
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gemini-api-ui",
      function () {
        return require("private-next-pages/gemini-api-ui.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gemini-api-ui"])
      });
    }
  